document.addEventListener('DOMContentLoaded', () => {
  const infoWrapper = document.querySelector('.product__info-wrapper');
  const openPrdtInfo = document.querySelector('#open-product-info');
  const selectOptionBtn = document.querySelector('#select-an-option-button');

  if (!infoWrapper || !openPrdtInfo) return;

  let startY = 0;
  let startX = 0;
  let isDraggingButton = false;
  let wrapperStartY = 0;
  let isDraggingWrapper = false;
  let isDraggingTopArea = false;
  let hasMoved = false;

  if (selectOptionBtn) {
    selectOptionBtn.addEventListener('click', () => {
      infoWrapper.classList.add('expanded');
    });
  }

  // openPrdtInfo tap vs drag logic
  openPrdtInfo.addEventListener('touchstart', (e) => {
    startY = e.touches[0].clientY;
    startX = e.touches[0].clientX;
    isDraggingButton = false;
  });

  openPrdtInfo.addEventListener('touchmove', (e) => {
    const diffY = e.touches[0].clientY - startY;
    const diffX = e.touches[0].clientX - startX;
    if (Math.abs(diffY) > 10 || Math.abs(diffX) > 10) {
      isDraggingButton = true;
    }
  });

  openPrdtInfo.addEventListener('touchend', () => {
    if (!isDraggingButton) {
      if (infoWrapper.classList.contains('expanded')) {
        infoWrapper.classList.remove('expanded');
      } else {
        infoWrapper.classList.add('expanded');
      }
    }
    isDraggingButton = false;
  });

  openPrdtInfo.addEventListener('click', () => {
    if (infoWrapper.classList.contains('expanded')) {
      infoWrapper.classList.remove('expanded');
    } else {
      infoWrapper.classList.add('expanded');
    }
  });

  // Swipe on infoWrapper with interaction allowance
  infoWrapper.addEventListener('touchstart', (e) => {
    wrapperStartY = e.touches[0].clientY;
    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;
    hasMoved = false;

    if (!infoWrapper.classList.contains('expanded')) {
      isDraggingWrapper = true;
      return;
    }

    const selectors = [
      '.variant-selects',
      '.product-form__input',
      '.product-form__quantity'
    ];

    const touchTarget = e.target;

    const insideAllowedArea = selectors.some(selector => touchTarget.closest(selector) !== null);

    const titleElem = infoWrapper.querySelector('.title_with_price');
    let insideTitleArea = false;

    if (titleElem) {
      const rect = titleElem.getBoundingClientRect();
      const extendedTop = rect.top - 70;

      if (
        touchY >= extendedTop &&
        touchY <= rect.bottom &&
        touchX >= rect.left &&
        touchX <= rect.right
      ) {
        insideTitleArea = true;
      }
    }

    if (insideAllowedArea || insideTitleArea) {
      isDraggingTopArea = true;
      // Do NOT preventDefault here yet — allow scrolling/tapping unless drag happens
    }
  });

  infoWrapper.addEventListener('touchmove', (e) => {
    const currentY = e.touches[0].clientY;
    const diffY = currentY - wrapperStartY;

    if (isDraggingWrapper) {
      if (diffY < -30) {
        infoWrapper.classList.add('expanded');
        isDraggingWrapper = false;
      }
      e.preventDefault();
      hasMoved = true;
    } else if (isDraggingTopArea) {
      if (Math.abs(diffY) > 10) {
        // User started dragging, so prevent scroll now
        e.preventDefault();
        hasMoved = true;
      }

      if (diffY > 30 && diffY < 100) {
        infoWrapper.classList.remove('expanded');
        isDraggingTopArea = false;
      }
    }
  });

  infoWrapper.addEventListener('touchend', (e) => {
    if (!hasMoved && isDraggingTopArea) {
      // It was a tap, not a drag, so allow normal interaction (do nothing)
    }
    isDraggingWrapper = false;
    isDraggingTopArea = false;
    hasMoved = false;
  });
});
